import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NullCheckPipe } from './null-check.pipe';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        NullCheckPipe
    ],
    exports: [
        NullCheckPipe
    ]
})
export class NullCheckModule { }